// extracted by mini-css-extract-plugin
export default {"Scoreboard":"WebScoreboard-module__Scoreboard__tSDnX","FullWidth":"WebScoreboard-module__FullWidth__yD9kt"};